import React from "react";

// Açık = yeşil, Kapalı = kırmızı. Yeşil OPEN'a verildiği için ANSWERED lacivert'e
// taşındı; dört durumun da birbirinden ayırt edilebilir kalması gerekiyor.
// STATUS_META tek kaynaktır: talep listeleri, detay başlığı ve timeline hepsi buradan okur.
export const STATUS_META = {
    OPEN: { label: "Açık", color: "#2BA66B", bg: "#e7f6ee" },
    IN_PROGRESS: { label: "İşlemde", color: "#E8833A", bg: "#fdf0e6" },
    ANSWERED: { label: "Yanıtlandı", color: "#221C5D", bg: "#eaf0f8" },
    CLOSED: { label: "Kapalı", color: "#dc3545", bg: "#fdeaec" },
};

export const PRIORITY_META = {
    LOW: { label: "Düşük", color: "#8a93a6", bg: "#f0f1f4" },
    MEDIUM: { label: "Orta", color: "#221C5D", bg: "#eaf0f8" },
    HIGH: { label: "Yüksek", color: "#E8833A", bg: "#fdf0e6" },
    URGENT: { label: "Acil", color: "#dc3545", bg: "#fdeaec" },
};

// Backend TicketCategory enum'u ile birebir aynı olmalı. GENERAL ve INTEGRATION
// V95'te kaldırıldı (GENERAL → OTHER, INTEGRATION → TECHNICAL eşlendi); eski
// kayıtları taşıyan bir istemci kalırsa etiket boş görünmesin diye burada tutuluyorlar.
export const CATEGORY_META = {
    TECHNICAL: "Teknik Destek",
    BUG: "Hata Bildirimi",
    BILLING: "Muhasebe",
    FEATURE_REQUEST: "Özellik ve Geliştirme Talebi",
    OTHER: "Diğer",
    GENERAL: "Diğer",
    INTEGRATION: "Teknik Destek",
};

export const STATUS_OPTIONS = ["OPEN", "IN_PROGRESS", "ANSWERED", "CLOSED"];
export const PRIORITY_OPTIONS = ["LOW", "MEDIUM", "HIGH", "URGENT"];
// Açılır listelerde bu sırayla çizilir.
export const CATEGORY_OPTIONS = ["TECHNICAL", "BUG", "BILLING", "FEATURE_REQUEST", "OTHER"];

const pillStyle = (m) => ({
    display: "inline-flex",
    alignItems: "center",
    background: m?.bg || "#f0f1f4",
    color: m?.color || "#8a93a6",
    fontWeight: 600,
    fontSize: ".72rem",
    padding: ".22rem .6rem",
    borderRadius: 999,
    whiteSpace: "nowrap",
});

export const StatusPill = ({ status }) => {
    const m = STATUS_META[status] || { label: status };
    return <span style={pillStyle(m)}>{m.label}</span>;
};

export const PriorityPill = ({ priority }) => {
    const m = PRIORITY_META[priority] || { label: priority };
    return <span style={pillStyle(m)}>{m.label}</span>;
};

/**
 * Talep numarasının kullanıcıya gösterilen biçimi: 521 → "000521".
 * Backend yalın sayı gönderir (sıralama ve arama sayısal kalsın diye); sıfır
 * doldurma tek yerde, burada tanımlıdır. Ekranlarda başına "#" konur.
 */
export const formatTicketNo = (no) =>
    (no === null || no === undefined) ? "" : String(no).padStart(6, "0");

export const fmtDateTime = (d) => (d ? new Date(d).toLocaleString("tr-TR") : "-");
